<template>
    <v-card>
    <v-row v-if="isNotSupervisor && !isAdmin">
      <v-col>
      <v-alert type="warning" dense dismissible>您在系统中还不是主管，请联系管理员帮您设置。</v-alert>
      </v-col>
    </v-row>
    <v-row v-if="haveMultipleDepartments">
      <v-col>
      <v-alert type="warning" dense dismissible>{{isAdmin?'您是管理员，':''}}您有多个部门的管理权限，请注意从右上角切换您的部门，完成打分。</v-alert>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col cols="12" md="4" v-for="(en, i) in entries" :key="i">
        <v-card class='mx-auto mb-10' :to="en.to">
          <v-img :src="en.img" class="white--text align-end">
            <v-card-title>{{en.title}}</v-card-title>
          </v-img>
            
        </v-card>
      </v-col>
    </v-row>
    </v-card>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  export default {
    name: 'HomePage',
 
    data: () => ({
      entries:[
        {to:'/perfdesign', img:require('@/assets/p5.jpg'), title:'绩效考核目标'},
        {to: '/perfscore', img:require('@/assets/p4.jpg'), title:'绩效考核打分'},
        {to:'/perfsum', img:require('@/assets/p6.jpg'), title:'绩效考核成绩'}]
    }),
    created() {
      // console.log(`my cur manage department:${JSON.stringify(this.myCurManageDepartment)}`)
    },
    computed: {
      ...mapGetters(['myManageDepartments']),
      ...mapState(['cur_user', 'myCurManageDepartment']),
      isAdmin() {
        return this.cur_user && this.cur_user.isAdmin
      },
      isNotSupervisor() {
        return !this.myCurManageDepartment
      },
      haveMultipleDepartments() {
        return this.myManageDepartments && this.myManageDepartments.length > 1
      }
    },
    methods:{
    }
  }
</script>
